import React from "react";
import PropTypes from "prop-types";
import styles from "./NavIcon.module.css";
import {
  getNavPartProps,
  isNavigationBarBrandRefresh,
} from "../navigationBarBrandRefreshClasses";

const NavIcon = ({ children, onClick, ariaLabel, className = "" }) => {
  const isBrandRefresh = isNavigationBarBrandRefresh();

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${isBrandRefresh ? "" : styles.navIcon} ${className}`.trim()}
      aria-label={ariaLabel}
      data-part={getNavPartProps("nav-icon")}
    >
      {children}
    </button>
  );
};

NavIcon.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  className: PropTypes.string
};

NavIcon.defaultProps = {
  onClick: undefined,
  ariaLabel: "",
  className: ""
};

export default NavIcon;
